/**
 * Finds the appropriate Notion template ID based on homework type and source.
 * Requires exact match on both dimensions (case-insensitive). No fallback.
 */
export function findTemplate(
  templates:
    | Array<{
        templateId: string
        source: string | null
        homeworkType: string | null
      }>
    | null
    | undefined,
  homeworkType: string | null | undefined,
  sourceName: string | null | undefined,
): string | null {
  if (!templates || templates.length === 0) return null
  if (!homeworkType || !sourceName) return null

  const normalizedType = homeworkType.toUpperCase()
  const normalizedSource = sourceName.toUpperCase()

  const match = templates.find(
    (t) =>
      t.homeworkType?.toUpperCase() === normalizedType &&
      t.source?.toUpperCase() === normalizedSource,
  )

  return match?.templateId ?? null
}
